import { useState } from "react";
import { useLoginContext } from "../../../App";
import { fetchAvailableWidgetTemplates } from "../../../services/b2b-reporting-apiServices";
import { useQuery } from "@tanstack/react-query";

const useGettingAvailableWidgetTemplates = (scope = 'AREA_INDICATOR') => {
    const { loginData } = useLoginContext();
    const [loading, setLoading] = useState(false);

    const getAvailableDashbTemplates = async () => {
        try {
            setLoading(true);
            const response = await fetchAvailableWidgetTemplates(loginData.accessToken, scope);
            return response;
        } catch (error) {
            console.error('Error fetching available dashboard templates', error);
        } finally {
            setLoading(false);
        }
    };

    const { data: availableWidgetTemplates } = useQuery({
        queryKey: ['availableWidgetTemplates', scope, loginData.loggedOrganizationUuid],
        queryFn: getAvailableDashbTemplates,
        enabled: !!scope,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: false,
        refetchIntervalInBackground: false,
        retry: 0,
        staleTime: 1000 * 60 * 15,
        cacheTime: 1000 * 60 * 20,
    });

    return { availableWidgetTemplates, loading };

}

export default useGettingAvailableWidgetTemplates;